import { useState, useEffect, useRef } from "react"
import { Dropdown, Modal, Button, Form } from "react-bootstrap"
import { format } from 'date-fns';
import { useParams, Link, useLocation } from "react-router-dom";
import CaseListingHeader from '../../Components/Litigation/CaseListingHeader'
import InputLabel from "@material-ui/core/InputLabel"
import Arrow from "../../../Static/RawImages/arrow.png"
import { getCase, updateEFiling, addPocketExpance, caseDocumentUpload, requestCourtFee, addComment, getComments, listInvoice, createInvoice,updateAdditionalDetails } from "../../../API/litigationApis";
import { showToast } from "../../../utils/handleToast"
import Pagination from "../../Components/pagination/Pagination"
import AddExpenseModal from "../../Components/Litigation/AddExpenseModal"
import UpdateDocumentModal from "../../Components/Litigation/UpdateDocumentModal"
import UpdateCaseNumbrModal from "../../Components/Litigation/UpdateCaseNumbrModal"
import ViewExpensesModal from "../../Components/Litigation/ViewExpensesModal"
// import { expanceListingAPI } from "../../../API/litigationApis" // Removed: Not used
import { Eye, FileText } from "lucide-react"
import { Mail } from "lucide-react";
import ViewDocumentsModal from "../../Components/Litigation/ViewDocumentsModal"
import CasePdfsModal from "../../Components/Litigation/ViewCasePaperModal"
import EmailHistory from "../../Components/EmailHistory";
import RequestCourtFeesModal from "../../Components/Litigation/RequestCourtFeesModal";
import AddCommentModal from "../../Components/Litigation/AddCommentModal";
import InvoicesModal from "../../Components/Litigation/InvoicesModal";
import ViewDetailsModal from "../../Components/Litigation/ViewDetailsModal";
import UpdateAdditionalDetailsModal from "../../Components/Litigation/UpdateAdditionalDetailsModal";

// The full list of potential fields for reference (kept for context, but not functionally needed)
// const FIELD_MAP = { ... }; // REMOVED the FIELD_MAP definition

// --- REMOVED HELPER FUNCTIONS (Now in UpdateAdditionalDetailsModal.jsx) ---
// const formatDDMMYYYYToDateInput = (dateString) => { ... };
// const createEmptyParty = (index) => ({ ... });
// const createEmptyLan = (index) => ({ ... });
// const getMaxPartiesCount = (case_item, prefix) => { ... };
// const formatDateForAPI = (dateString) => { ... };


export default function CaseListingPage() {
    // Get batch ID from URL parameters
    const { batchId } = useParams()
    const location = useLocation();

    const [showExpensesModal, setShowExpensesModal] = useState(false)
    const handleViewExpenses = (case_item) => {
        setSelectedCase(case_item)
        setShowExpensesModal(true)
    }
    const [showDocumentsModal, setShowDocumentsModal] = useState(false)

    // State for cases data
    const [cases, setCases] = useState([])
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null,
        page_number: 1
    })

    // State for reload functionality
    const [hitReload, setHitReload] = useState(false)

    // State for search parameters (used by the header)
    const [searchParameter, setSearchParameter] = useState({})

    // State for selected cases
    const [selectedCases, setSelectedCases] = useState([])
    const [selectedValue, setSelectedValue] = useState([])
    const [showCasePdfsModal, setShowCasePdfsModal] = useState(false);
    const [selectedCasePdfs, setSelectedCasePdfs] = useState([]);

    // Modal states
    const [showUpdateDocumentModal, setShowUpdateDocumentModal] = useState(false)
    const [showUpdateCaseNumberModal, setShowUpdateCaseNumberModal] = useState(false)
    const [showExpenseModal, setShowExpenseModal] = useState(false)
    const [showNewModal, setShowNewModal] = useState(false) // This is for UpdateAdditionalDetailsModal
    const [selectedCase, setSelectedCase] = useState(null)
    const [showEmailHistory, setShowEmailHistory] = useState(false);
    const [showUpdateCaseStatusModal, setShowUpdateCaseStatusModal] = useState(null)

    // --- NEW STATE FOR ACTIONS ---
    const [showRequestCourtFeesModal, setShowRequestCourtFeesModal] = useState(false);
    const [caseTypeKey, setCaseTypeKey] = useState('');
    const [courtFeeLoading, setCourtFeeLoading] = useState(false);

    const [showInvoicesModal, setShowInvoicesModal] = useState(false);
    const [invoices, setInvoices] = useState([]);
    const [loadingInvoices, setLoadingInvoices] = useState(false);

    // Invoice form states
    const [invoiceAmount, setInvoiceAmount] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [invoiceLoading, setInvoiceLoading] = useState(false);

    const [showAddCommentModal, setShowAddCommentModal] = useState(false);
    const [newComment, setNewComment] = useState('');
    const [comments, setComments] = useState([]);
    const [commentLoading, setCommentLoading] = useState(false);
    const [loadingComments, setLoadingComments] = useState(false);

    const [showViewDetailsModal, setShowViewDetailsModal] = useState(false);


    // Form states
    const [documentFile, setDocumentFile] = useState(null)
    const [documentType, setDocumentType] = useState('')
    const [caseNumber, setCaseNumber] = useState('')
    const [caseDate, setCaseDate] = useState("")
    const [expenseType, setExpenseType] = useState('')
    const [expenseAmount, setExpenseAmount] = useState('')

    // Loading states for modals
    const [documentLoading, setDocumentLoading] = useState(false)
    const [caseNumberLoading, setCaseNumberLoading] = useState(false)
    const [expenseLoading, setExpenseLoading] = useState(false)

    // Add refs to track if component is mounted and prevent duplicate calls
    const isMounted = useRef(true)
    // FIX: New ref to manage initial fetch to prevent double calling due to searchParameter initial state
    const hasInitialized = useRef(false);

    const handleShowEmailHistory = (case_item) => {
        setSelectedCase(case_item);
        setShowEmailHistory(true);
    };

    const handleViewDocuments = (case_item) => {
        setSelectedCase(case_item)
        setShowDocumentsModal(true)
    }

    // --- REMOVED: DYNAMIC PARTY & LAN STATES (coBorrowerCount, coBorrowers, lanCount, additionalLans) ---
    // --- REMOVED: formData STATE (All fields) ---


    // --- REMOVED: updateDetails (Update Additional Details API Call) ---

    // --- REMOVED: handleChange (Update Additional Details Form Change) ---

    // --- REMOVED: handlePartyChange (Update Additional Details Party Array Change) ---

    // --- REMOVED: handleCountChange (Update Additional Details Party Count Change) ---

    // --- REMOVED: handleLanChange (Update Additional Details LAN Change) ---

    // --- REMOVED: handleLanCountChange (Update Additional Details LAN Count Change) ---


    const updateCasestatus = async (status) => {
        try {
            const apiBody = {
                case_id: selectedCase?.case_id,
                case_status: status,  // Include the selected status from modal
            };

            const response = await updateAdditionalDetails(apiBody);
            console.log(apiBody);

            if (response?.data) {
                showToast({ variant: "success", message: response.message || "Case status updated successfully!" });
                // Optionally reload cases or update UI here
            } else {
                throw new Error(response?.message || "Failed to update case status");
            }
        } catch (error) {
            console.error("Error updating case status:", error);
            showToast({ variant: "error", message: error.message || "Failed to update case status" });
        }
    };


    // Fetch cases from API
    const fetchCases = async (page = 1, searchParams = {}) => {
        try {
            setLoading(true)

            // Prepare API parameters - include batch_id if available
            const params = {
                page: page,
                ...searchParams
            }

            // Add batch_id to params if batchId is available from URL
            if (batchId) {
                params.case_batch_id = batchId // or whatever the API expects
                // You might need to adjust this parameter name based on your API
                // Common variations: batch_id, case_batch_id, batchId
            }

            // Get client_id from query params
            const queryParams = new URLSearchParams(location.search);
            const clientId = queryParams.get('client');
            if (clientId) {
                params.client = clientId;
            }

            const response = await getCase(params)

            if (response?.status && response?.data) {
                setCases(response.data.results || [])
                setPagination({
                    count: response.data.count || 0,
                    next: response.data.next,
                    previous: response.data.previous,
                    page_number: response.data.page_number || page
                })
            } else {
                throw new Error(response?.message || "Failed to fetch cases")
            }
        } catch (error) {
            console.error("Error fetching cases:", error)
            showToast({
                variant: "error",
                message: error.message || "Failed to fetch cases"
            })
            setCases([])
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(pagination.count / 20)

    // FIX: Consolidated and modified useEffect logic to prevent multiple calls on mount
    useEffect(() => {
        // This condition prevents the fetch if searchParameter is an empty object
        // AND the component has already initialized (to handle React Strict Mode or header re-renders)
        if (Object.keys(searchParameter).length === 0 && hasInitialized.current && !batchId) {
            return;
        }

        const timeoutId = setTimeout(() => {
            // We always call with page=1 initially or on filter change
            fetchCases(1, searchParameter);
            hasInitialized.current = true;
        }, 500);

        return () => clearTimeout(timeoutId);

    }, [batchId, searchParameter, location.search]);

    // Reload effect (kept separate for explicit hitReload action)
    useEffect(() => {
        if (hitReload) {
            const timeoutId = setTimeout(() => {
                fetchCases(pagination.page_number, searchParameter)
                setHitReload(false)
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [hitReload, pagination.page_number, searchParameter])

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    // Toggle selection of a case
    const toggleCaseSelection = (caseId) => {
        if (selectedCases.includes(caseId)) {
            setSelectedCases(selectedCases.filter((id) => id !== caseId))
        } else {
            setSelectedCases([...selectedCases, caseId])
        }
    }

    // Toggle selection of all cases
    const toggleAllCases = () => {
        if (selectedCases.length === cases.length) {
            setSelectedCases([])
        } else {
            setSelectedCases(cases.map((case_item) => case_item.case_id))
        }
    }

    // Handle pagination
    const handlePageChange = (page) => {
        fetchCases(page, searchParameter)
    }

    // Action handlers
    const handleViewCasePaper = (case_item) => {
        setSelectedCase(case_item);
        setSelectedCasePdfs(case_item.case_pdfs || []);
        setShowCasePdfsModal(true);
    };

    const handleUpdateDocument = (case_item) => {
        setSelectedCase(case_item)
        setDocumentFile(null)
        setDocumentType('')
        setShowUpdateDocumentModal(true)
    }

    const handleUpdateCaseNumber = (case_item) => {
        setSelectedCase(case_item)
        setCaseNumber(case_item.e_filing_case_number || '')
        setShowUpdateCaseNumberModal(true)
    }

    // ✅ SIMPLIFIED: Only sets the case and opens the modal
    const handleUpdateAdditionalDetails = (case_item) => {
        setSelectedCase(case_item);
        // The modal's internal useEffect handles all the data preparation from selectedCase
        setShowNewModal(true);
    }
    
    const handleAddExpense = (case_item) => {
        setSelectedCase(case_item)
        setShowExpenseModal(true)
    }

    const handleUpdateCaseStatus = (case_item) => {
        setSelectedCase(case_item);
        setShowUpdateCaseStatusModal(true);
    };

    // --- NEW HANDLERS FOR ACTIONS ---

    // Function to fetch comments for the selected case
    const fetchComments = async (caseId) => {
        if (!caseId) return;
        setLoadingComments(true);
        setComments([]);
        try {
            const response = await getComments(caseId);
            if (response?.status && response?.data) {
                setComments(response.data.results || response.data);
            } else {
                throw new Error(response?.message || "Failed to fetch comments");
            }
        } catch (error) {
            console.error("Error fetching comments:", error);
            showToast({ variant: "error", message: error.message || "Failed to fetch comments" });
            setComments([]);
        } finally {
            setLoadingComments(false);
        }
    };

    // Function to fetch invoices for the selected case (CORRECTED USAGE)
    const fetchInvoices = async (caseId) => {
        if (!caseId) return;
        setLoadingInvoices(true);
        setInvoices([]);
        try {
            // FIX: Ensure correct key is used to resolve the "?0=458" issue
            const response = await listInvoice({ case_id: caseId });

            if (response?.status && response?.data) {
                setInvoices(response.data);
            } else {
                throw new Error(response?.message || "Failed to fetch invoices");
            }
        } catch (error) {
            console.error("Error fetching invoices:", error);
            showToast({ variant: "error", message: error.message || "Failed to fetch invoices" });
            setInvoices([]);
        } finally {
            setLoadingInvoices(false);
        }
    };


    const handleRequestCourtFees = (case_item) => {
        setSelectedCase(case_item);
        setCaseTypeKey(''); // Reset the key state
        setShowRequestCourtFeesModal(true);
    };

    const handleInvoices = (case_item) => {
        setSelectedCase(case_item);
        setInvoiceAmount(''); // Reset form
        setInvoiceNumber(''); // Reset form
        setInvoiceDate(''); // Reset form
        setShowInvoicesModal(true);
        fetchInvoices(case_item.case_id); // Fetch existing invoices
    };

    const handleAddComment = (case_item) => {
        setSelectedCase(case_item);
        setNewComment(''); // Reset form state
        setShowAddCommentModal(true);
        fetchComments(case_item.case_id); // Fetch existing comments
    };

    const handleViewDetails = (case_item) => {
        setSelectedCase(case_item);
        setShowViewDetailsModal(true);
    };
    // --- END NEW HANDLERS ---


    // Modal submit handlers

    // Modified submit handler for Request Court Fees
    const submitRequestCourtFees = async () => {
        if (!caseTypeKey.trim()) {
            showToast({ variant: "error", message: "Please select a case document type" });
            return;
        }

        try {
            setCourtFeeLoading(true);

            const body = {
                case_id: selectedCase.case_id,
                type_of_case: caseTypeKey.trim(), // Use the selected key
            };

            const response = await requestCourtFee(body); // API: /litigation/api/request_court_fee/ - POST
            if (response?.status) {
                showToast({ variant: "success", message: response.message || "Court fee request sent successfully" });
                setShowRequestCourtFeesModal(false);
            } else {
                throw new Error(response?.message || "Failed to send court fee request");
            }
        } catch (error) {
            console.error("Error sending court fee request:", error);
            showToast({ variant: "error", message: error.message || "Failed to send court fee request" });
        } finally {
            setCourtFeeLoading(false);
        }
    };

    // New submit handler for Add Comment
    const submitAddComment = async () => {
        if (!newComment.trim()) {
            showToast({ variant: "error", message: "Comment cannot be empty" });
            return;
        }

        try {
            setCommentLoading(true);

            const body = {
                case_id: selectedCase.case_id,
                comment: newComment.trim(),
            };

            const response = await addComment(body); // API: /litigation/api/add_comment/ - POST

            if (response?.status) {
                showToast({ variant: "success", message: response.message || "Comment added successfully" });
                setNewComment(''); // Clear input
                fetchComments(selectedCase.case_id); // Refresh comments list
            } else {
                throw new Error(response?.message || "Failed to add comment");
            }
        } catch (error) {
            console.error("Error adding comment:", error);
            showToast({ variant: "error", message: error.message || "Failed to add comment" });
        } finally {
            setCommentLoading(false);
        }
    };

    // New submit handler for Generate Invoice (CORRECTED API Payload)
    const submitGenerateInvoice = async () => {
        // Check all required fields (amount, number, date)
        if (!invoiceAmount || isNaN(invoiceAmount) || parseFloat(invoiceAmount) <= 0 || !invoiceNumber.trim() || !invoiceDate) {
            showToast({ variant: "error", message: "Please fill in all required invoice fields: amount, number, and date." });
            return;
        }

        try {
            setInvoiceLoading(true);

            const body = {
                case_id: selectedCase.case_id,
                invoice_number: invoiceNumber.trim(),
                invoice_date: invoiceDate,
                invoice_amount: parseFloat(invoiceAmount),
            };

            const response = await createInvoice(body); // API: /litigation/api/create/case/invoice

            if (response?.status) {
                showToast({ variant: "success", message: response.message || "Invoice generated and sent successfully (Email 16 triggered)" });
                setInvoiceAmount('');
                setInvoiceNumber('');
                setInvoiceDate('');
                fetchInvoices(selectedCase.case_id); // Refresh invoice list
            } else {
                throw new Error(response?.message || "Failed to generate invoice");
            }
        } catch (error) {
            console.error("Error generating invoice:", error);
            showToast({ variant: "error", message: error.message || "Failed to generate invoice" });
        } finally {
            setInvoiceLoading(false);
        }
    };


    const submitDocumentUpdate = async () => {
        if (!documentFile || !documentType.trim()) {
            showToast({
                variant: "error",
                message: "Please select a file and enter document type"
            })
            return
        }

        try {
            setDocumentLoading(true)

            const formData = new FormData()
            formData.append('case_id', selectedCase.case_id)
            formData.append('document_file', documentFile)
            formData.append('document_type', documentType.trim())

            const response = await caseDocumentUpload(formData)

            if (response?.status) {
                showToast({
                    variant: "success",
                    message: "Document uploaded successfully"
                })
                setShowUpdateDocumentModal(false)
                fetchCases(pagination.page_number, searchParameter) // Refresh the list
            } else {
                throw new Error(response?.message || "Failed to upload document")
            }
        } catch (error) {
            console.error("Error uploading document:", error)
            showToast({
                variant: "error",
                message: error.message || "Failed to upload document"
            })
        } finally {
            setDocumentLoading(false)
        }
    }

    const submitCaseNumberUpdate = async () => {
        if (!caseNumber.trim()) {
            showToast({
                variant: "error",
                message: "Please enter a case number"
            })
            return
        }

        try {
            setCaseNumberLoading(true)

            const body = {
                case_id: selectedCase.case_id,
                case_number: caseNumber.trim(),
                case_date: caseDate
            }

            const response = await updateEFiling(body)

            if (response?.status) {
                showToast({
                    variant: "success",
                    message: "Case number updated successfully"
                })
                setShowUpdateCaseNumberModal(false)
                fetchCases(pagination.page_number, searchParameter) // Refresh the list
            } else {
                throw new Error(response?.message || "Failed to update case number")
            }
        } catch (error) {
            console.error("Error updating case number:", error)
            showToast({
                variant: "error",
                message: error.message || "Failed to update case number"
            })
        } finally {
            setCaseNumberLoading(false)
        }
    }

    const submitExpense = async () => {
        if (!expenseType.trim() || !expenseAmount.trim()) {
            showToast({
                variant: "error",
                message: "Please enter both expense type and amount"
            })
            return
        }

        if (isNaN(expenseAmount) || parseFloat(expenseAmount) <= 0) {
            showToast({
                variant: "error",
                message: "Please enter a valid amount"
            })
            return
        }

        try {
            setExpenseLoading(true)

            const body = {
                case_id: selectedCase.case_id,
                amount: parseFloat(expenseAmount),
                expense_type: expenseType.trim()
            }

            const response = await addPocketExpance(body)

            if (response?.status) {
                showToast({
                    variant: "success",
                    message: "Expense added successfully"
                })
                setShowExpenseModal(false)
                fetchCases(pagination.page_number, searchParameter) // Refresh the list
            } else {
                throw new Error(response?.message || "Failed to add expense")
            }
        } catch (error) {
            console.error("Error adding expense:", error)
            showToast({
                variant: "error",
                message: error.message || "Failed to add expense"
            })
        } finally {
            setExpenseLoading(false)
        }
    }

    const getStatusBadgeClass = (statusType) => {
        if (!statusType) return 'text-secondary'

        switch (statusType.toLowerCase()) {
            case 'section 17 filed':
                return 'text-success'
            case 'notice served':
                return 'text-warning'
            case 'first hearing':
                return 'text-info'
            case 'active':
                return 'text-success'
            case 'closed':
                return 'text-danger'
            case 'npa':
                return 'text-warning'
            default:
                return 'text-secondary'
        }
    }

    // Helper function to get the status for Filing Status
    const getFilingStatus = (caseNo) => {
        return caseNo ? 'Filed' : 'Not Filed';
    }

    // Format currency helper
    const formatCurrency = (amount) => {
        if (!amount) return '--'
        return `₹ ${parseFloat(amount).toLocaleString('en-IN')}`
    }

    return (
        <>
            {/* Add breadcrumb or header to show current batch if needed */}
            {batchId && (
                <div className="mb-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/admin/litigation/batches">Batches</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Batch {batchId} Cases
                            </li>
                        </ol>
                    </nav>
                </div>
            )}

            <CaseListingHeader
                setSearchParameter={setSearchParameter}
                setHitReload={setHitReload}
            />
            <hr className="mt-3 col-md-4 mb-5" />

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2 text-muted">Loading cases...</p>
                </div>
            ) : cases.length === 0 ? (
                <div className="text-center py-5">
                    <p className="text-muted">No cases found{batchId ? ` for batch ${batchId}` : ''}</p>
                </div>
            ) : (
                <>
                    {/* Cases count and bulk actions */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <p className="text-muted">
                                Showing {cases.length} of {pagination.count} cases{batchId ? ` for batch ${batchId}` : ''}
                            </p>
                        </div>
                        <div className="col-md-6 text-end">
                            {selectedCases.length > 0 && (
                                <span className="text-info">
                                    {selectedCases.length} case(s) selected
                                </span>
                            )}
                        </div>
                    </div>

                    {cases.map((case_item, index) => (
                        <div key={case_item.case_id}>
                            <div className="row d-flex justify-between batch-listing">
                                {/* Left column - Case info (Refined Display) */}
                                <div className="col-md-4">
                                    <div className="d-flex align-start">
                                        <div className="form-check me-3 mt-1">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={selectedCases.includes(case_item.case_id)}
                                                onChange={() => toggleCaseSelection(case_item.case_id)}
                                            />
                                        </div>
                                        <div className="w-100">
                                            <p className="mb-2">
                                                <div>
                                                    <b className="text-black">
                                                        {case_item.customer_name || 'N/A'}
                                                    </b>
                                                </div>
                                            </p>

                                            <p className="mb-2">
                                                <span className="badge bg-primary text-uppercase me-2">
                                                    {case_item?.batch?.relief_sought}
                                                </span>
                                                <span className="badge bg-info text-uppercase">
                                                    {case_item.product_name || case_item.product_group}
                                                </span>
                                            </p>

                                            <hr className="my-2" />

                                            <p className="mb-2">
                                                <span className="text-muted">Client:</span>
                                                <span className="fw-bold ms-1">
                                                    {case_item.client_name || 'N/A'}
                                                </span>
                                            </p>


                                            <p className="mb-2">
                                                <span className="text-muted">Branch:</span>
                                                <span className="fw-bold ms-1">
                                                    {case_item.branch_name || case_item.batch?.branch_name || 'N/A'}
                                                    {case_item.batch?.client_contact_no && (
                                                        <span className="text-muted ms-2">
                                                            ({case_item.batch.client_contact_no})
                                                        </span>
                                                    )}
                                                </span>
                                            </p>

                                            <p className="mb-2">
                                                LAN Number: {case_item.lan_number || 'N/A'}
                                            </p>
                                            <p className="mb-2">
                                                E Filing Case Number: {case_item.e_filing_case_number || 'N/A'}
                                            </p>

                                            <hr className="my-2" />

                                            <p className="mb-2 fw-bold">
                                                Claim Amount: {formatCurrency(case_item.claim_amount)}
                                            </p>

                                            <hr className="my-2" />

                                            {/* Filing Status - Filed / Not Filed */}
                                            <div className="mb-2">
                                                <span className="text-muted">Filing Status:</span>
                                                <span className={`fw-bold ms-1 ${getFilingStatus(case_item.case_no) === 'Filed' ? 'text-success' : 'text-danger'}`}>
                                                    {getFilingStatus(case_item.case_no)}
                                                </span>
                                            </div>

                                            {case_item.state && (
                                                <div className="mt-1">
                                                    <small className="text-muted">State: {case_item.state}</small>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Middle column - Case timeline as table */}
                                <div className="col-md-5">
                                    <div className="">
                                        <table className="table table-bordered table-striped table-hover rounded overflow-hidden">
                                            <tbody>
                                                <tr className="bg-gray">
                                                    <td className="">Assigned Date</td>
                                                    <td className="">{case_item?.batch?.assignment_date || "--"}</td>
                                                </tr>
                                                <tr>
                                                    <td className="">Filing Date</td>
                                                    <td className="">{case_item?.batch?.case_date || "--"}</td>
                                                </tr>
                                                <tr className="bg-gray">
                                                    <td className="">Previous Date</td>
                                                    <td className="">{case_item.previous_hearing_date || "--"}</td>
                                                </tr>
                                                <tr className="bg-gray">
                                                    <td className="">Next Date</td>
                                                    <td className="">{case_item.next_hearing_date || "--"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Right column - Actions Dropdown */}
                                <div className="col-md-3 ps-5">
                                    <InputLabel id="label" className="mb-1">
                                        Action
                                    </InputLabel>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic" className="w-100 text-start select-style">
                                            <span className="w-100">
                                                Select
                                            </span>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="select-style-dropdown">

                                            {/* --- Existing Actions --- */}
                                            <Dropdown.Item onClick={() => handleViewCasePaper(case_item)}>
                                                View Case Paper
                                            </Dropdown.Item>

                                            <Dropdown.Item onClick={() => handleUpdateCaseNumber(case_item)}>
                                                Update E-Filing / Case Number
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleAddExpense(case_item)}>
                                                Out-of-pocket expenses
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleUpdateAdditionalDetails(case_item)}>
                                                Update Additional Details
                                            </Dropdown.Item>
                                            {/*-----Newly Added Actions -----*/}
                                            <Dropdown.Item onClick={() => handleRequestCourtFees(case_item)}>
                                                Request Court Fees
                                            </Dropdown.Item>

                                            <Dropdown.Item onClick={() => handleInvoices(case_item)}>
                                                Invoices
                                            </Dropdown.Item>

                                            <Dropdown.Item onClick={() => handleAddComment(case_item)}>
                                                Add Comments
                                            </Dropdown.Item>

                                            <Dropdown.Item onClick={() => handleViewDetails(case_item)}>
                                                View Details
                                            </Dropdown.Item>

                                            {/* --- External Link --- */}
                                            {case_item.case_shorten_url && (
                                                <Dropdown.Item>
                                                    <a href={case_item.case_shorten_url} target="_blank" rel="noopener noreferrer">
                                                        View Online Case
                                                    </a>
                                                </Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    {/* Add the View Expenses Icon below the dropdown */}
                                    <div className="mt-2 d-flex justify-content-start gap-3">
                                        {/* Removed View Expenses and View Documents actions as requested */}
                                        <div
                                            className="d-flex flex-column align-items-center justify-content-center p-2 cursor-pointer"
                                            onClick={() => handleShowEmailHistory(case_item)}
                                            title="View Email History"
                                            style={{ width: "100px", cursor: 'pointer' }}
                                        >
                                            <Mail size={22} className="mb-1 text-primary cursor-pointer" />
                                            <span className="text-primary text-center cursor-pointer">Email History</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr className="mt-4 mb-4" />
                        </div>
                    ))}

                    {/* Pagination - Right aligned */}
                    <div className="d-flex justify-content-end">
                        <Pagination
                            current={pagination.page_number}
                            total={pagination.total_pages}
                            onPageChange={handlePageChange}
                            totalPages={totalPages}
                        />
                    </div>

                    {/* Bulk Actions Bar */}
                    {selectedCases.length > 0 && (
                        <div className="fixed-bottom bg-light border-top p-3 shadow">
                            <div className="container-fluid">
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <span className="fw-bold">{selectedCases.length} case(s) selected</span>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-sm btn-outline-primary me-2">
                                            Bulk Update
                                        </button>
                                        <button className="btn btn-sm btn-outline-success me-2">
                                            Export Selected
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-secondary"
                                            onClick={() => setSelectedCases([])}
                                        >
                                            Clear Selection
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* Update Additional Details Modal (now a separate component) */}
            <UpdateAdditionalDetailsModal
                show={showNewModal}
                onHide={() => setShowNewModal(false)}
                selectedCase={selectedCase}
                onSuccess={() => setHitReload(true)}
            />

            {/* View Case paper 	*/}
            <CasePdfsModal
                show={showCasePdfsModal}
                onHide={() => setShowCasePdfsModal(false)}
                casePdfs={selectedCasePdfs}
                caseId={selectedCase?.case_id}
            />

            {/* Update Document Modal */}
            <UpdateDocumentModal showUpdateDocumentModal={showUpdateDocumentModal} setShowUpdateDocumentModal={setShowUpdateDocumentModal} setDocumentFile={setDocumentFile} documentType={documentType} setDocumentType={setDocumentType} submitDocumentUpdate={submitDocumentUpdate} documentLoading={documentLoading} />

            {/* Update Case Number Modal */}
            <UpdateCaseNumbrModal showUpdateCaseNumberModal={showUpdateCaseNumberModal} setShowUpdateCaseNumberModal={setShowUpdateCaseNumberModal} setCaseNumber={setCaseNumber} caseNumber={caseNumber} submitCaseNumberUpdate={submitCaseNumberUpdate} caseNumberLoading={caseNumberLoading} setCaseDate={setCaseDate} caseDate={caseDate} />

            {/* Add Expense Modal */}
            <AddExpenseModal showExpenseModal={showExpenseModal} setShowExpenseModal={setShowExpenseModal} expenseType={expenseType} setExpenseType={setExpenseType} expenseAmount={expenseAmount} setExpenseAmount={setExpenseAmount} submitExpense={submitExpense} expenseLoading={expenseLoading} selectedCase={selectedCase} />

            {/* View Expenses Modal */}
            <ViewExpensesModal
                showExpensesModal={showExpensesModal}
                setShowExpensesModal={setShowExpensesModal}
                selectedCase={selectedCase}
            />

            {/* View Documents Modal */}
            <ViewDocumentsModal
                showDocumentsModal={showDocumentsModal}
                setShowDocumentsModal={setShowDocumentsModal}
                selectedCase={selectedCase}
            />

            {/* Email History Modal */}
            <EmailHistory
                show={showEmailHistory}
                setShow={setShowEmailHistory}
                caseId={selectedCase?.case_id}
                isMasked={true}
                borrowerEmail={selectedCase?.email}
            />


            {/* Updated RequestCourtFeesModal call */}
            <RequestCourtFeesModal
                show={showRequestCourtFeesModal}
                onHide={() => setShowRequestCourtFeesModal(false)}
                selectedCase={selectedCase}
                caseTypeKey={caseTypeKey}
                setCaseTypeKey={setCaseTypeKey}
                submitRequestCourtFees={submitRequestCourtFees}
                loading={courtFeeLoading}
            />

            <InvoicesModal
                show={showInvoicesModal}
                onHide={() => setShowInvoicesModal(false)}
                selectedCase={selectedCase}
                invoices={invoices}
                loadingInvoices={loadingInvoices}
                invoiceAmount={invoiceAmount}
                setInvoiceAmount={setInvoiceAmount}
                invoiceNumber={invoiceNumber}
                setInvoiceNumber={setInvoiceNumber}
                invoiceDate={invoiceDate}
                setInvoiceDate={setInvoiceDate}
                submitGenerateInvoice={submitGenerateInvoice}
                invoiceLoading={invoiceLoading}
            />

            <AddCommentModal
                show={showAddCommentModal}
                onHide={() => setShowAddCommentModal(false)}
                selectedCase={selectedCase}
                newComment={newComment}
                setNewComment={setNewComment}
                submitAddComment={submitAddComment}
                loading={commentLoading}
                comments={comments}
                loadingComments={loadingComments}
            />

            <ViewDetailsModal
                show={showViewDetailsModal}
                onHide={() => setShowViewDetailsModal(false)}
                selectedCase={selectedCase}
            />
        </>
    )
}